import React, { useContext } from 'react';
import Context from '../../../utils/context';
import UserMenu from './user_menu';

import styles from './index.module.css';

const AdminHeaderV2 = () => {
  const context = useContext(Context);
  const isMobile = context.viewport.getIsMobile();

  return (
    <header className='platform-header' id='hdr-content'>
      <div className='container-fluid'>
        <div className={`header-outr row align-items-center ${isMobile ? styles.mobileRow : ''}`}>
          <div className={isMobile ? styles.logoColMobile : 'col-2'}>
            <div className='hdr-logo'>
              <img
                alt='logo'
                id='logo'
                src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
              />
            </div>
          </div>

          <div className={isMobile ? styles.controlsColMobile : 'col-4 d-flex align-items-center justify-content-end'}>
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeaderV2;
